import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function associateTouchAttributionConfiguration({ rootId }) {
  return new NetworkRequestConfiguration({
    endpoint: 'attributions/touch_attributions/associate',
    method: NetworkRequestConfiguration.Methods.POST,
    bodyParameters: {
      rootId,
    },
  });
}

